import styled from 'styled-components';

export default function CustomInput(props) {
  const { value, setValue, placeholder, width, disabled, textAlign, onlyNumber, onFocus } = props;

  function handleClick(e) {
  }

  function handleChange(e) {
    if (onlyNumber) {
      setValue(e.target.value.replace(/[^0-9]/g, ''));
    } else {
      setValue(e.target.value);
    }
  }

  function handleFocus(e) {
    if (onFocus) onFocus(e);
  }

  function handleBlur(e) {
  }

  return (
    <Input $disabled={disabled}
      type='text'
      disabled={disabled}
      placeholder={placeholder}
      value={value}
      textAlign={textAlign}
      width={width}
      onClick={handleClick}
      onChange={handleChange}
      onFocus={handleFocus}
      onBlur={handleBlur} />
  )
}

const Input = styled.input`
	font-family: NotoSansKR-Regular;
	font-size: 14px;
	line-height: 20px;

	width: ${props => props.width ? `${props.width}px` : '100%'};
	height: 30px;

	padding: 0 8px;

	outline: none;
	border: 1px solid ${props => props.theme.line};
	border-radius: 5px;
	color: ${props => props.theme.text};
	background-color: ${props => props.theme.subBackground};

  text-align: ${props => props.textAlign};
  
  cursor: ${props => props.$disabled ? 'not-allowed' : 'pointer'};
	opacity: ${props => props.$disabled ? 0.4 : 1};

  transition: all 0.3s ease-in-out;
`;